<template src="@/pages/client/reflection/index.tpl.html"></template>

<script>
import dataStore from "@/services/api/store";
import survey from "@/pages/client/reflection/survey";
const PULSE_SURVEY_QUESTION_STORE = "CoachPulseSurveyQuestions";
const PULSE_SURVEY_STORE = "CoachPulseSurveys";
export default {
  data() {
    return {
      surveyQuestions: [],
      userAnswer: {},
      reflection: "",
      saving: false,
      loading: true,
      preview: true,
      btnValue: "Back",
      kpis: []
    };
  },
  components: {
    survey
  },
  created() {
    let q = dataStore
      .findAll(
        PULSE_SURVEY_QUESTION_STORE,
        { construct__pulse_survey: this.$route.params.id },
        { force: true }
      )
      .then(questions => {
        this.questions = questions;
        questions.map(q => (q.question_text = q.question));
        this.surveyQuestions = this.questions.filter(q => q.always);
      });

    let s = dataStore
      .find(PULSE_SURVEY_STORE, this.$route.params.id)
      .then(pulseSurvey => {
        this.pulseSurvey = pulseSurvey;
        this.userAnswer = pulseSurvey;
      });

    Promise.all([s, q]).then(() => {
      let pool = this.questions.filter(q => !q.always);
      if (pool.length <= this.pulseSurvey.daily_num_questions) {
        this.surveyQuestions = this.questions;
      } else {
        let qs = pool.slice(0, this.pulseSurvey.daily_num_questions);
        this.surveyQuestions = [...this.surveyQuestions, ...qs];
      }
      this.loading = false;
    });
  },
  methods: {
    save() {
      this.$router.push({
        name: "pulseSurveyDetail",
        params: {
          id: this.$route.params.id
        }
      });
    },
    updateAnswer() {},
    answerChanged() {}
  }
};
</script>

<style>
</style>
